import { render, staticRenderFns } from "./AutoServiceRadioOption.vue?vue&type=template&id=b88b720c"
import script from "./AutoServiceRadioOption.vue?vue&type=script&lang=ts"
export * from "./AutoServiceRadioOption.vue?vue&type=script&lang=ts"
import style0 from "./AutoServiceRadioOption.vue?vue&type=style&index=0&id=b88b720c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports